module.exports = __webpack_public_path__ + "static/media/button-google-play.5c681e17.png";